export default "__VITE_ASSET__p3AR6EiK__"